import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Group, NativeSelect, Text } from "@mantine/core";
import { AiOutlineEllipsis } from "react-icons/ai";
var PaginationBar = function (props) {
    var headerColor = props.headerColor
        ? "rgb(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ") !important")
        : undefined;
    var renderPageSelectOptions = function () {
        var totalPages = Math.ceil(props.totalRowItems / props.pageSize);
        var pages = [];
        for (var i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
        var cur = props.page;
        return (_jsx(Group, { children: pages.map(function (page) {
                return page === 1 || page === totalPages || Math.abs(page - cur) <= 1 ? (_jsx(ActionIcon, __assign({ onClick: function () { return props.setPage(page); }, variant: "light", disabled: props.page === page, sx: {
                        color: headerColor,
                        "&:hover": {
                            color: props.headerBg,
                            backgroundColor: props.headerColor
                                ? "rgba(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ", 0.75) !important")
                                : undefined,
                        },
                    } }, { children: page }), "pagination-page-".concat(page))) : Math.abs(page - cur) === 2 ? (_jsx(ActionIcon, __assign({ onClick: function () { return props.setPage(page); }, variant: "light", disabled: props.page === page, sx: {
                        color: headerColor,
                        "&:hover": {
                            color: props.headerBg,
                            backgroundColor: props.headerColor
                                ? "rgba(".concat(props.headerColor.r, ", ").concat(props.headerColor.g, ", ").concat(props.headerColor.b, ", 0.75) !important")
                                : undefined,
                        },
                    } }, { children: _jsx(AiOutlineEllipsis, {}) }), "pagination-page-".concat(page))) : null;
            }) }));
    };
    return (_jsxs(Group, __assign({ position: "center", spacing: "xl" }, { children: [_jsxs("div", __assign({ style: { display: "flex", flexDirection: "row" } }, { children: [_jsx(Text, __assign({ color: "gray", style: { paddingRight: 10, color: headerColor } }, { children: "Rows per page" })), _jsx(NativeSelect, { styles: {
                            input: {
                                lineHeight: "24px",
                                minHeight: 26,
                                height: 26,
                            },
                        }, style: {}, value: props.pageSize.toString(), data: ["10", "15", "25", "50"], onChange: function (e) {
                            return props.setPageSize(parseInt(e.currentTarget.value));
                        } })] })), renderPageSelectOptions(), _jsx(Text, __assign({ color: "gray", style: { color: headerColor } }, { children: "Showing ".concat(props.pageSize * (props.page - 1) + 1, "-").concat(Math.min(props.pageSize * props.page, props.totalRowItems), " of ").concat(props.totalRowItems, " items") }))] })));
};
export default PaginationBar;
